// extracted by css-extract-rspack-plugin
export default {"root":"AYKBK","wrap":"cAOWN","gap0_4":"id2F5","gap0_8":"W4EYQ","gap1":"zIwm4","gap1_6":"XVhnv","gap2":"mu2bc"};